import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeItem, updateItem } from "../..//redux/cart-items";
import CartItemSupplement from "../../components/Cart/CartItemSupplement";
import CartItemStateroom from "../../components/Cart/CartItemStateroom";

const CartPreview = () => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);

  const handleRemoveItem = (title, type) => {
    dispatch(removeItem({ title: title, type: type }));
  };

  // const handleUpdateItem = (item) => {
  //   dispatch(updateItem(item));
  // };

  // const handleClearCart = () => {
  //   dispatch(clearCart());
  // };

  const handleIncrement = (title, type) => {
    dispatch(updateItem({ title, type, action: "increment" }));
  };

  const handleDecrement = (title, type) => {
    dispatch(updateItem({ title, type, action: "decrement" }));
  };

  return (
    <div className="md:w-5/5 h-auto flex flex-col md:flex-row md:justify-between md:mx-auto">
      <div className="w-full md:w-4/4">
        <div className="py-0">
          {cartItems.map((item) => {
            if (item.supplement) {
              return (
                <CartItemSupplement
                  parent="cartPreview"
                  key={item.title}
                  item={item}
                  onRemove={handleRemoveItem}
                  onIncrement={handleIncrement}
                  onDecrement={handleDecrement}
                />
              );
            } else {
              return (
                <CartItemStateroom
                  parent="cartPreview"
                  key={item.title}
                  item={item}
                  onRemove={handleRemoveItem}
                  onIncrement={handleIncrement}
                  onDecrement={handleDecrement}
                />
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default CartPreview;
